/**
 * HR Layout — just a content wrapper, no sidebar.
 * Navigation is handled by the main BHEL AppLayout sidebar.
 */
import { useAuth } from '../hrAuth';

function greeting() {
  const h = new Date().getHours();
  return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
}

export default function Layout({ children }) {
  const { user } = useAuth();
  const isImpersonating = !!localStorage.getItem('hr_portal_admin_token');

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {isImpersonating && (
        <div style={{
          background: '#fef3c7', borderBottom: '1px solid #fcd34d',
          padding: '8px 24px', fontSize: 13, color: '#92400e'
        }}>
          Viewing HR portal as <strong>{user?.name}</strong> (admin mode)
        </div>
      )}
      <div style={{ padding: '28px 32px', flex: 1, overflowY: 'auto' }}>
        <div style={{ marginBottom: 24 }}>
          <span style={{ fontSize: 22, fontWeight: 700, color: '#1B2437' }}>
            {greeting()}, {user?.first_name || user?.name || user?.employee_id} 👋
          </span>
          <span style={{ marginLeft: 10, fontSize: 13, color: '#64718A' }}>
            {user?.designation ? `${user.designation} · ` : ''}
            {user?.employee_id}
          </span>
        </div>
        {children}
      </div>
    </div>
  );
}
